export const pluginCaseGerman = {
  title: 'GuestAI-Fälle',
  loading: 'GuestAI-Fälle werden geladen …',
  unavailable: 'GuestAI-Fälle können gerade nicht geladen werden.',
  forbidden: 'Für diese Fälle fehlt die aktuelle Plugin-Berechtigung.',
  open: 'Fall in GuestAI öffnen',
  linkUnavailable: 'Fall-Link derzeit nicht verfügbar.',
  retry: 'Erneut laden',
  states: {
    Open: 'Offen',
    Processing: 'Wird geprüft',
    ReplyPending: 'Antwort ausstehend',
    NeedsHuman: 'Menschliche Klärung nötig',
    Claimed: 'Übernommen',
    Resolved: 'Erledigt',
    Retired: 'Entfernt',
  },
  reasons: {
    NewGuestMessage: 'Neue Gastnachricht',
    HumanControlRequired: 'Menschliche Bearbeitung',
    ShadowNeedsHuman: 'Prüfung im Beobachtungsmodus',
    UnresolvedQuestion: 'Offene Frage',
    UnknownAttachment: 'Anhang muss geprüft werden',
    OutcomeUnknown: 'Versandausgang wird geklärt',
    ProcessingUnavailable: 'Bearbeitung nicht verfügbar',
    KnowledgeRequired: 'Wissen fehlt',
    AccessRequired: 'Zugangsfreigabe fehlt',
    QualityRequired: 'Qualitätsfreigabe fehlt',
    SourceConflict: 'Widersprüchliche Angaben',
  },
};
export const pluginCaseEnglish = {
  title: 'GuestAI cases',
  loading: 'Loading GuestAI cases …',
  unavailable: 'GuestAI cases cannot be loaded right now.',
  forbidden: 'Current plugin permission is required for these cases.',
  open: 'Open case in GuestAI',
  linkUnavailable: 'Case link is currently unavailable.',
  retry: 'Reload',
  states: {
    Open: 'Open',
    Processing: 'Under review',
    ReplyPending: 'Reply pending',
    NeedsHuman: 'Human review needed',
    Claimed: 'Claimed',
    Resolved: 'Resolved',
    Retired: 'Removed',
  },
  reasons: {
    NewGuestMessage: 'New guest message',
    HumanControlRequired: 'Human handling',
    ShadowNeedsHuman: 'Shadow review',
    UnresolvedQuestion: 'Unresolved question',
    UnknownAttachment: 'Attachment needs review',
    OutcomeUnknown: 'Send outcome under review',
    ProcessingUnavailable: 'Processing unavailable',
    KnowledgeRequired: 'Knowledge missing',
    AccessRequired: 'Access approval missing',
    QualityRequired: 'Quality approval missing',
    SourceConflict: 'Conflicting information',
  },
};
